<template>
    <div class="auction" v-wechat-title="title">
        <!--<top_nav class="auction_nav"></top_nav>-->
        <div class="banner">
            <div class="swiper-container banner-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide banner_slide" v-for="(item,index) in banners" :key='index'>
                        <a class="link_box"
                           :href="item.link"
                           target="_blank" rel="noopener noreferrer">
                            <img class="img" :src="item.thumb" alt="">
                        </a>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
            <div class="bg_con">
                嘉联华
                <div class="bg_dot"></div>
                {{type === 0? '竞拍':'竞租'}}
            </div>
        </div>
        <div class="modules">
            <div class="module_top">
                <div class="module">
                    <div class="top_left">
                        <div class="leftItem" :class="{active:category_id === item.id}" v-for="(item,index) in auction"
                             :key="index" @click="changeItem(item)">
                            {{ item.name }}
                        </div>
                    </div>
                    <!--<div class="top_right">-->
                    <!--<input class="search_input" v-model="search_key" type="text"-->
                    <!--@keyup="keyUp($event)"-->
                    <!--placeholder="输入关键字">-->
                    <!--<div class="search_img_box" @click="toSearch">-->
                    <!--<img src="../../assets/images/search.png" alt="">-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </div>
            <div class="module_bottom">
                <div class="bottom_left">
                    <div class="swiper-container bottom_left_img">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide banner_slide" v-for="(item,index) in subBanners" :key='index'>
                                <a class="sub_link" :href="item.link" target="_blank" rel="noopener noreferrer">
                                    <img class="img" :src="item.thumb" alt="">
                                </a>
                            </div>
                        </div>
                        <!--<div class="swiper-pagination"></div>-->
                    </div>
                    <!--<img class="bottom_left_img" src="../../assets/images/auction/house.png" alt="">-->
                </div>
                <div class="bottom_right">
                    <div class="tags">
                        <div class="tag" v-for="(item,index) in tags" :key="index">
                            {{ item }}
                        </div>
                    </div>
                    <div class="lines">
                        <div class="line"></div>
                        <div class="line_con">交易服务</div>
                        <div class="line"></div>
                    </div>
                    <div class="helps" v-show="!showHelp">
                        <div class="help_item" v-for="(item,index) in helpList" :key="item.id" v-show="index <= 7"
                             @click="changeTab(item)">
                            <div class="help_img">
                                <img class="img debt_img" :src="item.logo" alt="">
                            </div>
                            <!--<div class="help_img">-->
                            <!--<img class="img debt_img" src="../../assets/images/auction/guohu.png" alt="">-->
                            <!--</div>-->
                            <div class="help_title">{{ item.title}}</div>
                        </div>
                    </div>
                    <div class="helps" v-show="showHelp">
                        <div class="help_item" v-for="(item) in helpList" :key="item.id"
                             @click="changeTab(item)">
                            <div class="help_img">
                                <img class="img debt_img" :src="item.logo" alt="">
                            </div>
                            <!--<div class="help_img">-->
                            <!--<img class="img debt_img" src="../../assets/images/auction/guohu.png" alt="">-->
                            <!--</div>-->
                            <div class="help_title">{{ item.title}}</div>
                        </div>
                    </div>
                    <div class="more" @click="showHelp = !showHelp">查看更多>></div>
                    <div class="hot_line">客服专线：{{kfrxPhone}}</div>
                </div>
            </div>
        </div>
        <div class="flows_box">
            <!--<div class="flows pointer" @click="$router.push({name:'flow'})">-->
            <div class="flows ">
                <div class="flows_left">
                    {{ type === 0?'竞拍流程':'竞租流程' }}
                </div>
                <div class="flows_right">
                    <!--@click="changeFlow(item)" :class="{flowActive:flowId === item.id}"-->
                    <div class="flow" v-for="(item,index) in flowList" :key="index">
                        <img class="flow_arrow" src="../../assets/images/auction/flow_arrow.png" alt="">
                        <div class="flow_box">
                            <div class="flow_img">
                                <img class="flow_item_img" :src="item.logo" alt="">
                            </div>
                            <div class="flow_title">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="flow_content" v-for="(item,index) in flowList" :key="index" v-show="flowId === item.id">-->
            <!--<div v-html="item.content"></div>-->
            <!--</div>-->
        </div>
        <div class="screenBox"  :class="{screenBoxActive:isScroll}">
            <div class="searchBox">
                <div class="inputBox">
                    <input class="search_input" v-model="search_key" type="text"
                           @keyup="keyUp($event)"
                           placeholder="输入关键字">
                    <div class="search_img_box" @click="toSearch">
                        <img src="../../assets/images/search.png" alt="">
                    </div>
                </div>
            </div>

            <div class="filtrate_box">
                <div class="filtrate_title">用途：</div>
                <div class="filtrate">
                    <div class="filtrate_item" :class="{filtrateActive:is_style === item.id }"
                         v-for="(item,index) in useList" :key="index" @click="changeUseList(item)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="filtrate_box">
                <div class="filtrate_title">状态：</div>
                <div class="filtrate">
                    <div class="filtrate_item" :class="{filtrateActive:status === item.id }"
                         v-for="(item,index) in list" :key="index" @click="filtrateList(item)">
                        {{ item.label }}
                    </div>
                </div>
            </div>
        </div>

        <div class="house_list"  :class="{houseListActive:isScroll}">
            <div class="house_content">
                <div class="house_item pointer" v-for="(item,index) in goodsList" :key="index" @click="toDetail(item)">
                    <div class="loans" v-show="item.is_yjdk === 1">可贷款</div>
                    <div class="logo_box">
                        <img class="logo" :src="item.logo" alt="">
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="house_center">
                        <div class="center_item">
                            <div class="center_left" v-if="item.status === 2">
                                <div class="left_title">
                                    起拍价：
                                </div>
                                <div class="price">
                                    ￥{{ parseInt(item.price_cur).toLocaleString() }}元
                                </div>
                            </div>
                            <div class="center_left" v-else-if="item.status === 3">
                                <div class="left_title">
                                    成交价：
                                </div>
                                <div class="price">
                                    ￥{{ parseInt(item.price_cur).toLocaleString() }}元
                                </div>
                            </div>
                            <div class="center_left" v-else>
                                <div class="left_title">
                                    当前价：
                                </div>
                                <div class="price">
                                    ￥{{ parseInt(item.price_cur).toLocaleString() }}元
                                </div>
                            </div>
                            <div class="center_right" v-show="item.status === 1">
                                正在进行
                            </div>
                            <div class="center_right center_start" v-show="item.status === 2">
                                即将开始
                            </div>
                            <div class="center_right center_end"
                                 v-show="item.status === 3 || item.status === 4 || item.status === 4">
                                {{ item.status_des }}
                            </div>
                        </div>
                        <div class="center_item">
                            <div class="center_left">
                                <div class="left_title">
                                    评估价：
                                </div>
                                <div class="price">
                                    ￥{{ parseInt(item.price_guess).toLocaleString() }}元
                                </div>
                            </div>
                        </div>
                        <div class="center_item">
                            <div class="center_left">
                                <div class="left_title" v-show="item.status === 2">
                                    开拍时间：
                                </div>
                                <div class="price time" v-show="item.status === 2">
                                    {{ item.time_start }}
                                </div>
                                <div class="left_title" v-show="item.status === 1">
                                    预&nbsp;&nbsp;&nbsp;计：
                                </div>
                                <div class="left_title"
                                     v-show="item.status === 3 || item.status === 4 || item.status === 5">
                                    结&nbsp;&nbsp;&nbsp;束：
                                </div>
                                <div class="price time" v-show="item.status !== 2">
                                    {{ item.time_end }}
                                </div>
                                <div class="price time" v-show="item.status === 1">
                                    结束
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="house_bottom">
                        <div class="house_bottom_left">
                            <div>
                                {{ parseInt(item.number_view).toLocaleString() }}次围观
                            </div>
                            <div class="bottom_img">
                                <img src="../../assets/images/auction/view.png" alt="">
                            </div>

                        </div>
                        <div class="house_bottom_right">
                            <div>
                                {{ parseInt(item.number_join).toLocaleString() }}人报名
                            </div>
                            <div class="bottom_img">
                                <img src="../../assets/images/auction/apply.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-size="limit"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Swiper from "swiper";
import "swiper/css/swiper.css";
// import top_nav from '../../components/nav.vue'
import {
  banner,
  category,
  goods,
  flows,
  banner_sub,
  services,
  getStyleGoods,
} from "../../apiNew/index";

export default {
  name: "",
  data() {
    return {
      banners: [],
      type: 0,
      auction: [],
      category_id: "",
      search_key: "",
      page: 1,
      limit: 15,
      total: 0,
      tags: ["#低佣金", "#交易保障", "#资金安全", "#一站式服务"],
      helpList: [],
      flowList: [],
      goodsList: [],
      showHelp: false,
      // 用途
      useList: [
        {name: '不限', id: ''}
      ],
      is_style: "",
      // 状态
      list: [
        { label: "不限", id: "0" },
        { label: "正在进行", id: "1" },
        { label: "即将开始", id: "2" },
        { label: "已结束", id: "3" },
        { label: "已中止", id: "4" },
        { label: "已撤回", id: "5" },
      ],
      status: "0",
      flowId: "",
      subBanners: [],
      title: "",
      isScroll: false,
      kfrxPhone:'',
    };
  },
  created() {
    // console.log(window.location)
    this.kfrxPhone =  localStorage.getItem('kfrx')
    const that = this;
    if (window.location.pathname.split("/")[1] === "auction") {
      // console.log(0)
      this.type = Number(window.location.pathname.split("/")[2]);
      this.category_id = Number(window.location.pathname.split("/")[3]);
      that.getCategory();
      that.getlist();
      that.getFlow();
      if (this.type === 0) {
        this.title = "嘉联华 资产竞拍";
      } else if (this.type === 1) {
        this.title = "嘉联华 资产竞租";
      }
    }
    window.addEventListener("setItem", function(e) {
      // console.log(e)
      if(e.key === 'categoryType'){
        that.type = Number(e.newValue)
        that.getCategory();
      }
      if(e.key === 'categoryId'){
        that.category_id = Number(e.newValue)
        // console.log(that.category_id)
        // that.getCategory();
        that.getlist();
        that.getFlow();
        if (that.type === 0) {
          that.title = "嘉联华 资产竞拍";
        } else if (that.type === 1) {
          that.title = "嘉联华 资产竞租";
        }
      }
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.help();
    this.bannerImg();
    // this.getCategory();
    // this.getFlow();
    this.getlist();
    this.bannerSub();
    this.getUsedList();
  },
  // components: {top_nav},
  methods: {
	//  用途列表
    getUsedList() {
      getStyleGoods({})
        .then((res) => {
        //   console.log(res);
          this.useList = this.useList.concat(res.data)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 副广告
    bannerSub() {
      banner_sub({
        is_type: 1,
      })
        .then((res) => {
          // console.log(res)
          this.subBanners = res.data;
          this.$nextTick(() => {
            this.initSwiperSub();
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 副广告轮播
    initSwiperSub() {
      if (this.subBanners.length > 1) {
        new Swiper(".bottom_left_img", {
          loop: true,
          // on: {
          // 	click: function (e) {
          // 		console.log(e.target.dataset)
          // 		// jumpurl是在swiper-slide中动态绑定的data-jumpUrl属性，值是从后台获取的跳转链接
          // 		let url = e.target.dataset.jumpurl
          // 		window.location.href = url
          // 		// _this.bannerJump(url)
          // 	},
          // },
          autoplay: {
            disableOnInteraction: false,
          },
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          // navigation: {
          // 	nextEl: '.swiper-button-next',
          // 	prevEl: '.swiper-button-prev',
          // },
        });
      }
    },
    // 筛选状态
    filtrateList(item) {
      if (this.status === item.id) {
        this.status = "";
        // this.getlist()
      } else {
        this.status = item.id;
      }
      this.getlist();
    },
    // 筛选用途
    changeUseList(item) {
      if (this.is_style === item.id) {
        this.is_style = "";
      } else {
        this.is_style = item.id;
      }
      this.getlist();
    },
    // enter键搜索
    keyUp(event) {
      if (event.keyCode === 13) {
        this.toSearch();
      }
    },
    // 搜索
    toSearch() {
      this.getlist();
    },
    // 轮播广告
    bannerImg() {
      banner({ is_type: 1 })
        .then((res) => {
          // console.log(res)
          this.banners = res.data;
          this.$nextTick(() => {
            this.initSwiper();
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 点击切换选项
    changeItem(item) {
      // console.log(item)
      // console.log(this.category_id)
      // console.log(window.location.pathname.split('/')[2])
      var type = window.location.pathname.split("/")[2];
      this.$addStorageEvent("categoryId", item.id);
      this.$router.replace(`/auction/${type}/${item.id}`);
      this.category_id = item.id;
      // this.getlist();
    },
    // 资产分类
    getCategory() {
      category({
        is_type: this.type,
      })
        .then((res) => {
          console.log(res);
          this.auction = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 资产列表
    getlist() {
      // console.log(this.category_id)
      goods({
        page: this.page,
        limit: this.limit,
        category_id: this.category_id,
        is_style: this.is_style,
        search_key: this.search_key,
        status: this.status,
      })
        .then((res) => {
          // console.log(res)
          this.goodsList = res.data.data;
          this.total = res.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 交易服务
    help() {
      services({
        page: this.page,
        limit: this.limit,
      })
        .then((res) => {
          console.log(res);
          this.helpList = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 交易服务内容切换
    changeTab(item) {
      this.$router.push({ name: "deal", params: { id: item.id } });
      // this.$addStorageEvent('helpId', item.id)
    },
    //	流程
    getFlow() {
      // console.log(this.category_id)
      flows({
        category_id: this.category_id,
      })
        .then((res) => {
          console.log(res);
          this.flowList = res.data;
          if (res.data.length > 0) {
            // this.flowId = res.data[0].id
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 调转详情
    toDetail(item) {
      // localStorage.setItem('auctionId', item.id)
      var type = Number(window.location.pathname.split("/")[2]);
      this.$router.push({
        name: "auctionDetail",
        params: { id: item.id, type: type },
      });
    },
    initSwiper() {
      if (this.banners.length > 1) {
        new Swiper(".banner-container", {
          loop: true,
          // spaceBetween: 20,
          // slidesPerView: 1,
          // freeMode: true,
          // on: {
          // 	click: function (e) {
          // 		console.log(e.target.dataset)
          // 		// jumpurl是在swiper-slide中动态绑定的data-jumpUrl属性，值是从后台获取的跳转链接
          // 		let url = e.target.dataset.jumpurl
          // 		window.location.href = url
          // 		// _this.bannerJump(url)
          // 	},
          // },
          autoplay: {
            disableOnInteraction: false,
          },
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          // navigation: {
          // 	nextEl: '.swiper-button-next',
          // 	prevEl: '.swiper-button-prev',
          // },
        });
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getlist();
    },
    // 滚动监测
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      if (scrollTop >= 1275) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "auction";
</style>
